import React from 'react'
import '../styles/NotFoundView.css'

class NotFoundView extends React.Component {
  render() {
    return (
      <div className="nf-root">
        {/* Scanlines */}
        <div className="nf-scanlines" />
        {/* Horizontal sweep line */}
        <div className="nf-flicker" />
        {/* Perspective grid floor */}
        <div className="nf-grid" />
        {/* Breathing orb */}
        <div className="nf-orb" />
        {/* HUD corners */}
        <div className="nf-corner nf-tl" /><div className="nf-corner nf-tr" />
        <div className="nf-corner nf-bl" /><div className="nf-corner nf-br" />

        <div className="nf-content">
          <div className="nf-tag">SYS://vacway.admin &nbsp;—&nbsp; PROCESS TERMINATED</div>

          <div className="nf-glitch-wrap">
            <span className="nf-glitch" data-text="404">404</span>
          </div>

          <div className="nf-hline" />

          <h1 className="nf-title">PÁGINA &nbsp;<span className="nf-title-accent">NO ENCONTRADA</span></h1>

          <div className="nf-meta">
            <span><span className="nf-key">STATUS&nbsp;</span><span className="nf-val nf-red">0x404 FATAL</span></span>
            <span><span className="nf-key">MODULE&nbsp;</span><span className="nf-val">ROUTER_GUARD</span></span>
            <span><span className="nf-key">MEM&nbsp;&nbsp;&nbsp;&nbsp;</span><span className="nf-val">0xFF3A7C1D</span></span>
          </div>

          <p className="nf-desc">
            La ruta solicitada no existe en este sistema.<br />
            Regresa al panel de control para continuar.
          </p>

          <a href="/" className="nf-btn">
            <i className="fas fa-terminal" />
            <span>cd /home</span>
            <span className="nf-cursor">_</span>
          </a>
        </div>
      </div>
    )
  }
}

export default NotFoundView
